import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintApiManager: FootprintApiManager_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

